import QuoteAssignmentComponent from "./QuoteAssignmentComponent";
import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import axios from "axios";
import { Row, Col, Container, ListGroup, Button, Form, Table, Modal } from "react-bootstrap";

const QuoteItemForQuotePageComponent = ({
  id,
  updateQuote,
  getQuote,
  markAsProcessing,
  userQuoteAction,
  refreshQuotes,
  getStatusColor,
  adminDuplicateQuote,
  handleClose
}) => {
  const [product, setProduct] = useState(null);
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState("");
  const [needRefresh, setNeedRefresh] = useState(false);
  const [ctlsku, setCtlsku] = useState("");
  const [expireDate, setExpireDate] = useState("");
  const [todayDate, setTodayDate] = useState("");
  const [daysDifference, setDaysDifference] = useState("");
  const [quoteName, setQuoteName] = useState("");
  const [quoteItems, setQuoteItems] = useState([]);
  const isMultipleQuote = quoteItems.length > 1;
  const isExistingProductQuote = quoteItems.some((item) => item.product);
  const [editingItemId, setEditingItemId] = useState(null);
  const [editItemForm, setEditItemForm] = useState({});
  const [totalSellAmount, setTotalSellAmount] = useState(0);
  const [totalPurchaseAmount, setTotalPurchaseAmount] = useState(0);
  const [CTLSKUUpdated, setCTLSKUUpdated] = useState(false)

  const [previewImage, setPreviewImage] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);

  useEffect(() => {
    setQuoteName(quote?.name);
    const today = new Date();
    setTodayDate(today.toISOString().substring(0, 10));

    if (quote?.expireDate) {
      const expiryDate = new Date(quote.expireDate);
      const timeDiff = expiryDate - today;
      const dayDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
      setDaysDifference(dayDiff);
    }
  }, [quote]);

  useEffect(() => {
    setExpireDate(daysDifference);
  }, [daysDifference]);

  const refreshQuoteItem = () => {
    getQuote(id)
      .then((quote) => {
        setQuote(quote);

        const normalisedItems =
          quote?.items?.length > 1
            ? quote.items.map((item, index) => ({
              ...item,
              product: item.product || null,
              productName: item.product?.name || item.productName || quote.name,
              ctlsku:
                item.ctlsku ||
                item.product?.stock?.[0]?.ctlsku ||
                quote.ctlsku ||
                "",
              quantity: item.quantity || 1,
              expireIn: item.expireIn || daysDifference || "",
              clientImages: quote.clientImages[index]
            }))
            : [
              {
                product: quote.product || null,
                productName: quote.product?.name || quote.name,
                ctlsku: quote.product?.stock?.[0]?.ctlsku || quote.ctlsku || "",
                quantity: quote.quantity || 1,
                expireIn: daysDifference || "",
                clientImages: quote.clientImages[0]
              },
            ];

        setQuoteItems(normalisedItems);
        setProduct(normalisedItems[0]?.product || null);
        setCtlsku(normalisedItems[0]?.ctlsku || "");
      })
      .catch((er) => console.log(er));
  };

  useEffect(() => {
    refreshQuoteItem();
  }, [getQuote, id, refreshQuotes]);

  // console.log(getQuote, id, refreshQuotes, product);

  const handleUpdateNewQuote = async (e) => {
    if (e) e.preventDefault();
    if (!CTLSKUUpdated) {
      alert("Input CTLSKU field to complete the Quote")
      return;
    }
    if (!expireDate) {
      alert("Input Expires in field to complete the Quote")
      return;
    }

    try {
      const expireDays = parseInt(expireDate, 10);

      let expiryDateString = "";

      if (!isNaN(expireDays)) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + expireDays);
        expiryDateString = currentDate.toISOString().split("T")[0];
      }

      const updatedItems = quoteItems.map((item) => ({
        ...item,
        ctlsku: item.ctlsku || "",
      }));

      await updateQuote(id, {
        items: updatedItems,
        ctlsku: ctlsku,
        expireDate: expiryDateString,
        status: "Completed",
        adminMessage,
      });

      refreshQuoteItem();
      refreshQuotes();
      handleClose();
    } catch (error) {
      console.error("Error updating quote:", error);
      setError("Failed to update quote");
    }
  };

  /* **************** Image check (unvalid url) **************** */
  async function fetchImage(url) {
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      console.error(
        "There has been a problem with your fetch operation:",
        error
      );
    }
  }
  const [images, setImages] = useState([]);

  useEffect(() => {
    async function handleImages() {
      const imagesArray = [];

      if (quoteItems.length > 0 && quoteItems[0]?.product?.images?.length > 0) {
        for (const image of quoteItems[0].product.images) {
          let imagePath = image.path;

          if (imagePath.includes("http://")) {
            imagePath = imagePath.replace("http://", "https://");
          }

          imagesArray.push({
            original: imagePath,
            thumbnail: imagePath,
            url: imagePath,
            title: image.title,
            caption: image.name,
          });
        }
      } else if (quote?.clientImages?.length > 0) {
        for (const image of quote.clientImages) {
          let imagePath = image.path;

          if (imagePath.includes("http://")) {
            imagePath = imagePath.replace("http://", "https://");
          }

          imagesArray.push({
            original: imagePath,
            thumbnail: imagePath,
            url: imagePath,
            title: image.title,
            caption: image.name,
          });
        }
      }

      setImages(imagesArray);
    }

    handleImages();
  }, [quote, quoteItems]);


  /* **************** Complete Quote **************** */
  const [completeQuoteResponseState, setCompleteQuoteResponseState] =
    useState("");

  const [adminMessage, setAdminMessage] = useState("");

  const handleCompleteQuote = async () => {
    const normalisedQuoteItems =
      quoteItems?.length > 0
        ? quoteItems
        : quote?.items?.length > 0
          ? quote.items
          : [
            {
              product: quote?.product || product,
              productName: quote?.product?.name || product?.name || quote?.name,
            },
          ];

    const existingProductItems = normalisedQuoteItems.filter(
      (item) => item?.product
    );

    const invalidProducts = existingProductItems.filter((item) => {
      const p = item.product;

      const sellPrice = Number(p?.stock?.[0]?.price || item?.unitPrice || 0);
      // const displayPrice = Number(p?.displayPrice || item?.displayPrice || 0);

      return sellPrice <= 0
    });

    if (invalidProducts.length > 0) {
      const productNames = invalidProducts
        .map((item) => item.product?.name || item.productName || "Unknown product")
        .join(", ");

      setCompleteQuoteResponseState(
        `Please check product display price and sell price for: ${productNames}`
      );
      return;
    }

    try {
      const expireDays = parseInt(expireDate, 10);
      let expiryDateString;

      if (!isNaN(expireDays)) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + expireDays);
        expiryDateString = currentDate.toISOString().split("T")[0];
      }

      const updatedData = await markAsProcessing(
        id,
        expiryDateString,
        adminMessage,
        "Completed"
      );

      if (updatedData === "Please check product display price, sell price and purchase price." || updatedData.message === "Please check product display price, sell price and purchase price.") {
        setCompleteQuoteResponseState("Product display price, sell price and purchase price should be a valid price greater than 0.");
        return;
      }

      if (updatedData === "Product expire date is not exist!!!" || updatedData.message === "Product expire date is not exist!!!") {
        setCompleteQuoteResponseState("Product expire date does not exist!!!");
        return;
      }

      if (updatedData === "Product expire date is in the past." || updatedData.message === "Product expire date is in the past.") {
        setCompleteQuoteResponseState(
          "Product price valid date is in the past. Please update the product expired date."
        );
        return;
      }

      if (updatedData === "Quote status updated" || updatedData.message === "Quote status updated") {
        handleClose();
        refreshQuotes();
      }
    } catch (error) {
      console.error("Error updating quote:", error);
      setError("Failed to update quote");
    }
  };

  const receivedHandler = async (quoteId) => {
    markAsProcessing(quoteId)
      .then((data) => {
        if (data.quote) setQuote(data.quote);
        refreshQuotes();
      })
      .catch((err) => console.error("Error in userQuoteAction:", err));
  };

  const handleAssigned = (assignedTo) => {
    setQuote((current) => ({ ...current, assignedTo }));
    refreshQuotes();
  };

  const handleUserAcceptQuote = (quote, accept) => {
    // console.log("handleUserAcceptQuote", quote, accept);
    userQuoteAction(quote, accept)
      .then(() => {
        refreshQuotes();
      })
      .catch((err) => console.error("Error in userQuoteAction:", err));
  };

  const [updateQuoteButton, setUpdateQuoteButton] = useState(false);
  const updateQuoteButtonHandler = () => {
    setUpdateQuoteButton(true);
  };

  const [contacted, setContacted] = useState(false);
  const contactedClient = () => {
    if (updateQuoteButton === false && contacted === false) {
      setContacted(true);
    } else if (updateQuoteButton === false && contacted === true) {
      setContacted(false);
      setUpdateQuoteButton(false);
    } else if (updateQuoteButton === true && contacted === true) {
      setContacted(false);
      setUpdateQuoteButton(false);
    } else if (updateQuoteButton === true && contacted === false) {
      setContacted(false);
      setUpdateQuoteButton(false);
    }
  };

  // console.log(updateQuoteButton, contacted);
  const [duplicateCount, setDuplicateCount] = useState(1);
  const [processDuplicateQuotes, setProcessDuplicateQuotes] = useState(false);
  const [duplicateQuoteButton, setDuplicateQuoteButton] = useState(false);
  const [adminMessageButton, setAdminMessageButton] = useState(false);

  const handleAdminMessageButton = () => {
    if (adminMessageButton === true) {
      setAdminMessage("");
      setAdminMessageButton(false);
    } else {
      setAdminMessageButton(true);
    }
  };

  const duplicateQuoteHandler = (quoteId, number) => {
    setProcessDuplicateQuotes(true);
    adminDuplicateQuote(quoteId, number)
      .then(() => {
        refreshQuotes();
        handleClose();
        setProcessDuplicateQuotes(false);
      })
      .catch((err) => console.error("Error in adminDuplicateQuote:", err));
  };

  // console.log("quoteName", quoteName);

  const [nameUpdating, setNameUpdating] = useState(false);

  const adminUpdateQuoteName = async () => {
    try {
      setNameUpdating(true);
      const updatedData = await axios.put(
        "/api/quotes/admin/updateName?quoteId=" + quote._id,
        {
          quoteName: quoteName,
        }
      );
      if (updatedData.status === 200) {
        refreshQuotes();
        setNameUpdating(false);
        setUpdateName(false);
      }
      // console.log(updatedData);
    } catch (error) {
      console.error("Error updating quote:", error);
      setError("Failed to update quote");
    }
  };

  const [updateName, setUpdateName] = useState(false);

  const handleInputChange = (e) => {
    setQuoteName(e.target.value);
  };

  const startEditQuoteItem = (item, index) => {
    const rowId = item._id || index;

    setEditingItemId(rowId);

    setEditItemForm({
      productName: item.product?.name || item.productName || "",
      price: item.product?.stock?.[0]?.price || item.unitPrice || 0,
      purchasePrice:
        item.product?.stock?.[0]?.purchaseprice ||
        item.purchaseprice ||
        item.purchasePrice ||
        0,
    });
  };

  const submitQuoteItemUpdate = async (item, index) => {
    try {
      const productId = item.product?._id || item.product;

      // 1. Update quote item first
      const quoteUpdate = await axios.put(
        "/api/quotes/admin/updateQuoteItemProduct",
        {
          quoteId: quote._id,
          itemId: item._id,
          itemIndex: index,
          productId,
          productName: editItemForm.productName,
          price: Number(editItemForm.price),
          purchasePrice: Number(editItemForm.purchasePrice),
        }
      );

      // 2. Only continue if quote update success
      if (quoteUpdate.status === 200 && productId) {
        // 3. Get full product details
        const { data: fullProduct } = await axios.get(
          `/api/products/admin/get-one/${productId}`
        );

        // 4. Update stock price and purchase price
        const updatedStock = [...(fullProduct.stock || [])];

        if (updatedStock.length > 0) {
          updatedStock[0] = {
            ...updatedStock[0],
            price: Number(editItemForm.price),
            purchaseprice: Number(editItemForm.purchasePrice),
          };
        }

        // 5. Update full product
        await axios.put(`/api/products/admin/updateProduct/${productId}`, {
          ...fullProduct,
          name: editItemForm.productName,
          stock: updatedStock,
        });
      }

      setEditingItemId(null);
      setEditItemForm({});
      refreshQuoteItem();
    } catch (error) {
      console.error("Error updating quote item/product:", error);
    }
  };

  const handleQuoteItemFieldChange = (index, field, value) => {
    const updatedItems = [...quoteItems];

    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value.trim(),
    };

    setQuoteItems(updatedItems);
    setCTLSKUUpdated(true)
  };

  useEffect(() => {
    let totalSellPrice = 0
    let totalPurchasePrice = 0
    quoteItems?.map((item) => {
      totalSellPrice = totalSellPrice + (item.unitPrice * item.quantity)
      totalPurchasePrice = totalPurchasePrice + (item.purchasePrice * item.quantity)
    })
    setTotalSellAmount(totalSellPrice)
    setTotalPurchaseAmount(totalPurchasePrice)
  }, [quoteItems])

  return (
    <>
      {product && product ? (
        // ******************** EXISTING PRODUCT ********************
        <Container className="mt-3" fluid>

          <h2 className="text-center">{product.name}</h2>
          <hr />
          <Row className="">
            <Col lg={6} className="" hidden={isMultipleQuote}>
              <ImageGallery items={images} />
            </Col>
            <Col lg={isMultipleQuote ? 12 : 6}>
              <Row>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <Row>
                      {isMultipleQuote ? (
                        <Col>
                          <h5>{isMultipleQuote ? "Quote Items" : "Quote Item"}</h5>
                          <table className="table table-sm table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Product</th>
                                <th>CTL SKU</th>
                                <th>Qty</th>
                                <th>Sell Price</th>
                                <th>Purchase Price</th>
                                {quote.status === "Completed" ? ("") : (
                                  <th>Action</th>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {quoteItems.map((item, index) => (
                                <tr key={item._id || index}>
                                  <td>{index + 1}</td>

                                  <td>
                                    {editingItemId === (item._id || index) ? (
                                      <Form.Control
                                        size="sm"
                                        type="text"
                                        value={editItemForm.productName}
                                        onChange={(e) =>
                                          setEditItemForm({
                                            ...editItemForm,
                                            productName: e.target.value,
                                          })
                                        }
                                      />
                                    ) : (
                                      item.product?.name || item.productName || quote?.name
                                    )}
                                  </td>

                                  <td>{item.product?.stock?.[0]?.ctlsku || item.ctlsku}</td>

                                  <td>{item.quantity}</td>

                                  <td>
                                    {editingItemId === (item._id || index) ? (
                                      <Form.Control
                                        size="sm"
                                        type="number"
                                        value={editItemForm.price}
                                        onChange={(e) =>
                                          setEditItemForm({
                                            ...editItemForm,
                                            price: e.target.value,
                                          })
                                        }
                                      />
                                    ) : (
                                      `$${item.product?.stock?.[0]?.price || item.unitPrice || 0}`
                                    )}
                                  </td>

                                  <td>
                                    {editingItemId === (item._id || index) ? (
                                      <Form.Control
                                        size="sm"
                                        type="number"
                                        value={editItemForm.purchasePrice}
                                        onChange={(e) =>
                                          setEditItemForm({
                                            ...editItemForm,
                                            purchasePrice: e.target.value,
                                          })
                                        }
                                      />
                                    ) : (
                                      `$${item.product?.stock?.[0]?.purchaseprice ||
                                      item.purchaseprice ||
                                      item.purchasePrice ||
                                      0}`
                                    )}
                                  </td>
                                  {quote?.status !== "Completed" ? (
                                    <td>
                                      {editingItemId === (item._id || index) ? (
                                        <>
                                          <Button
                                            size="sm"
                                            className="CTL_btn p-1"
                                            onClick={() => submitQuoteItemUpdate(item, index)}
                                          >
                                            Submit
                                          </Button>

                                          <Button
                                            size="sm"
                                            variant="secondary"
                                            className="p-1 ms-1"
                                            onClick={() => {
                                              setEditingItemId(null);
                                              setEditItemForm({});
                                            }}
                                          >
                                            Cancel
                                          </Button>
                                        </>
                                      ) : item.product?._id || item.product ? (
                                        <Button
                                          size="sm"
                                          className="CTL_btn p-1"
                                          onClick={() => startEditQuoteItem(item, index)}
                                        >
                                          Edit Product
                                        </Button>
                                      ) : (
                                        <Button
                                          size="sm"
                                          className="CTL_btn p-1"
                                          onClick={() => window.open("/admin/create-new-product")}
                                        >
                                          Create Product
                                        </Button>
                                      )}
                                    </td>
                                  ) : null}
                                </tr>

                              ))}
                            </tbody>
                          </table>
                          {
                            totalPurchaseAmount && totalSellAmount ? (
                              <>
                                <h6 style={{ textAlign: "right" }}>
                                  Purchase Total :{" "}

                                  <span
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${totalPurchaseAmount.toFixed(2)}
                                  </span>
                                  <br />
                                  Selling Total :{" "}
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                    }}
                                  >
                                    ${totalSellAmount.toFixed(2)}
                                  </span>
                                </h6>
                              </>
                            ) : (null)
                          }
                          {quote?.status !== "Completed" ? (
                            <>
                              <Button
                                className="CTL_btn p-1 pe-3 ps-3 mt-0"
                                onClick={handleCompleteQuote}
                                disabled={
                                  completeQuoteResponseState ===
                                  "Product price valid date is in the past. Please update the product expired date."
                                }
                              >
                                Complete
                              </Button>

                              {completeQuoteResponseState ===
                                "Product expire date does not exist!!!" ? (
                                <input
                                  className="ms-2 mt-4 pb-1"
                                  type="number"
                                  placeholder="1 day before expire"
                                  value={expireDate}
                                  required
                                  onChange={(e) => setExpireDate(e.target.value)}
                                />
                              ) : null}
                            </>
                          ) : null}
                        </Col>
                      ) : (
                        <Col>
                          <h6>Product Code: {product?.stock[0]?.ctlsku}</h6>
                          <h6>Supplier Code: {product?.stock[0]?.suppliersku}</h6>
                          <h6>Supplier: {product?.supplier}</h6>
                          <h6>
                            Product Price:
                            <span
                              style={{
                                color:
                                  product?.stock[0]?.price > 0 ? "black" : "red",
                              }}
                            >
                              {" "}
                              $ {product?.stock[0]?.price}
                            </span>
                          </h6>
                          <h6>
                            Display Price:
                            <span
                              style={{
                                color: product?.displayPrice > 0 ? "black" : "red",
                              }}
                            >
                              {" "}
                              $ {product?.displayPrice}
                            </span>
                          </h6>

                          <h6
                            style={{
                              color:
                                product?.expireDate &&
                                  new Date(
                                    product.expireDate
                                      .split(" ")[1]
                                      .split("/")
                                      .reverse()
                                      .join("-")
                                  ) < new Date()
                                  ? "red"
                                  : "",
                            }}
                          >
                            Product Expires on:{" "}
                            {product.expireDate
                              ? product.expireDate.split(" ")[1]
                              : "NaN"}
                          </h6>
                          <h6 hidden={!quote?.expireDate}>
                            Quote Expires on:{" "}
                            {quote?.expireDate?.substring(0, 10)} 【
                            <span
                              style={{
                                color: `${Math.abs(daysDifference) > 7 ? "" : "red"
                                  }`,
                              }}
                            >
                              {daysDifference}
                            </span>
                            】
                          </h6>
                          <td>
                            {quote.status === "Completed" ? null : (
                              <>
                                <Button
                                  className="CTL_btn p-1 pe-3 ps-3 mt-2"
                                  onClick={() => {
                                    setNeedRefresh(true);
                                    setCompleteQuoteResponseState("");
                                    receivedHandler(quote?._id);
                                    window.open(
                                      `/admin/edit-product/${product._id}`
                                    );
                                  }}
                                >
                                  Edit <i class="bi bi-box-arrow-up-right"></i>
                                </Button>
                                <br />
                                <Button
                                  className="CTL_btn p-1 pe-3 ps-3 mt-2"
                                  onClick={() => {
                                    setNeedRefresh(false);
                                    refreshQuoteItem();
                                  }}
                                  hidden={needRefresh === false}
                                >
                                  Refresh
                                </Button>
                                <Button
                                  className="CTL_btn p-1 pe-3 ps-3 mt-2"
                                  onClick={handleCompleteQuote}
                                  disabled={
                                    completeQuoteResponseState ===
                                    "Product price valid date is in the past. Please update the product expired date."
                                  }
                                  hidden={needRefresh === true}
                                >
                                  Complete
                                </Button>
                                <br />
                                <textarea
                                  className="mt-2 w-100"
                                  placeholder="add admin message"
                                  value={adminMessage}
                                  onChange={(e) =>
                                    setAdminMessage(e.target.value)
                                  }
                                />
                                {completeQuoteResponseState ===
                                  "Product expire date does not exist!!!" ? (
                                  <input
                                    className="mt-2"
                                    type="number"
                                    placeholder="1 day before expire"
                                    value={expireDate}
                                    required
                                    onChange={(e) =>
                                      setExpireDate(e.target.value)
                                    }
                                  />
                                ) : null}
                                <br />
                                {completeQuoteResponseState && (
                                  <span className="text-danger">
                                    {completeQuoteResponseState}
                                  </span>
                                )}
                              </>
                            )

                            }
                          </td>
                        </Col>
                      )}
                    </Row>
                    {
                      quote.repeatPurchase.length > 0 ? (
                        <Row className="m-1" style={{ backgroundColor: "#f0ead2", width: "50%" }}>
                          <Col>
                            <h6>Purchase History:</h6>
                            {
                              quote.repeatPurchase.map((item) => {
                                return <p>Purchased on : {item.purchasedDate?.substring(0, 10)}</p>
                              })
                            }
                          </Col>
                        </Row>
                      ) : ("")
                    }

                    <QuoteAssignmentComponent quoteId={id} assignedTo={quote?.assignedTo} onAssigned={handleAssigned} />

                    <Row>
                      {quote.status === "Completed" ? (
                        <>
                          {quote.existingProduct ? null : (
                            <>
                              <hr className="m-0" />
                              <h6 className="mt-1">
                                Quoted Name: {quote.name}
                              </h6>
                              <h6 className="mt-1">Quoted Description: </h6>
                              <p>{quote.userDescription}</p>
                            </>
                          )}

                          {/* <hr className="mb-1" /> */}
                          {!isMultipleQuote ? (
                            <>
                              <h6>Customer reference image </h6>
                              <img
                                src={quote.clientImages?.[0]?.path}
                                alt="Customer images"
                                style={{ width: "250px", height: "250px", objectFit: "cover" }}
                              />
                            </>
                          ) : null}

                          <hr className="mb-2" />
                          <h6>
                            Satus:{" "}
                            <span
                              style={{
                                color: getStatusColor(quote?.status),
                                fontWeight: "bold",
                              }}
                            >
                              {quote.status ? quote.status : null}
                            </span>
                          </h6>
                          <h6>
                            Action:{" "}
                            <span
                              style={{
                                color: quote.accepted
                                  ? "green"
                                  : quote.accepted === undefined
                                    ? "black"
                                    : "red",
                              }}
                            >
                              {quote.accepted === undefined
                                ? "Waiting"
                                : quote.accepted
                                  ? "Accepted"
                                  : "Declined"}
                            </span>{" "}
                            {quote.accepted === false ? (
                              <button
                                onClick={() => {
                                  handleUserAcceptQuote(quote._id, true);
                                }}
                                hidden={updateQuoteButton === false}
                              >
                                {" "}
                                Mark as Accepted
                              </button>
                            ) : null}
                          </h6>

                          <button
                            className="w-auto ms-3"
                            onClick={updateQuoteButtonHandler}
                            hidden={
                              updateQuoteButton === true || contacted === false
                            }
                          >
                            Update Quote
                          </button>
                          <Form hidden={updateQuoteButton === false}>
                            <h4 className="mb-3">Update Quote Item:</h4>
                            <Form.Group as={Row} className="mb-3">
                              <Form.Label column sm="3">
                                CTL Sku:
                              </Form.Label>
                              <Col sm="9">
                                <Form.Control
                                  type="text"
                                  placeholder="CTL SKU"
                                  name="ctlsku"
                                  value={ctlsku}
                                  required
                                  onChange={(e) => setCtlsku(e.target.value)}
                                />
                              </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                              <Form.Label column sm="3">
                                Expires in:
                              </Form.Label>
                              <Col sm="9">
                                <Form.Control
                                  type="number"
                                  placeholder="1 day before expire"
                                  value={expireDate}
                                  required
                                  onChange={(e) =>
                                    setExpireDate(e.target.value)
                                  }
                                />
                              </Col>
                            </Form.Group>

                            <Button
                              type="submit"
                              className="CTL_btn p-1 pe-3 ps-3"
                              onClick={handleUpdateNewQuote}
                            >
                              Submit
                            </Button>
                            <br />
                            <Button
                              className="CTL_btn p-1 pe-3 ps-3 mt-2"
                              onClick={() =>
                                window.open(
                                  `/admin/edit-product/${product._id}`
                                )
                              }
                            >
                              Edit Product{" "}
                              <i class="bi bi-box-arrow-up-right"></i>
                            </Button>
                          </Form>
                          {quote.accepted === false ? (
                            <div>
                              <hr />
                              <h6>
                                User:{" "}
                                <span>
                                  {quote.user?.name +
                                    " " +
                                    quote.user?.lastName}
                                </span>
                              </h6>
                              <h6 className="mt-1" hidden={!quote.user?.mobile}>
                                Mobile: <span>{quote.user?.mobile}</span>
                              </h6>
                              <h6 className="mt-1" hidden={!quote.user?.phone}>
                                Phone: <span>{quote.user?.phone}</span>
                              </h6>
                              <h6 className="mt-1">
                                Company: <span>{quote.user?.company}</span>
                              </h6>
                              <h6 className="mt-1">
                                Site: <span>{quote.user?.location}</span>
                              </h6>
                              <Form.Check
                                type="checkbox"
                                label=" Contacted Client"
                                onClick={() => contactedClient()}
                              />
                            </div>
                          ) : null}
                        </>
                      ) : null}
                    </Row>
                  </ListGroup.Item>
                </ListGroup>
              </Row>
            </Col>
          </Row >
        </Container >
      ) : (
        // ******************** NEW PRODUCT ********************
        <Container className="mt-3" fluid>
          <h4 className="mb-3">Admin Part:</h4>

          <Table bordered responsive size="sm">
            <thead>
              <tr>
                <th>#</th>
                <th>Product Name</th>
                <th>Description</th>
                <th>Qty</th>
                <th>Image</th>
                <th>CTL SKU</th>
              </tr>
            </thead>

            <tbody>
              {quoteItems.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{index + 1}</td>

                  <td>{item.productName || quote?.name}</td>

                  <td>
                    {item.userDescription ||
                      item.description ||
                      quote?.userDescription}
                  </td>

                  <td>{item.quantity}</td>
                  <td>
                    {item.clientImages?.path ? (
                      <img
                        src={item.clientImages.path}
                        alt="quote"
                        onClick={() => {
                          setPreviewImage(item.clientImages.path);
                          setShowImageModal(true);
                        }}
                        style={{
                          width: "55px",
                          height: "55px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                          cursor: "pointer"
                        }}
                      />
                    ) : (
                      <span>No Image</span>
                    )}
                  </td>

                  <td>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="CTL SKU"
                      value={item.ctlsku || ""}
                      onChange={(e) =>
                        handleQuoteItemFieldChange(index, "ctlsku", e.target.value)
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Form.Group
            as={Row}
            className="mb-3"
            hidden={adminMessageButton === false}
          >
            <Form.Label column sm="3">
              Admin Message:
            </Form.Label>
            <Col sm="9">
              <Form.Control
                as="textarea"
                placeholder="add message here"
                value={adminMessage}
                name="adminMessage"
                onChange={(e) =>
                  setAdminMessage(e.target.value)
                }
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="1" className="ms-2">
              Expires in:
            </Form.Label>

            <Col sm="2">
              <Form.Control
                type="number"
                placeholder="1 day before expire"
                value={expireDate}
                required
                name="expireDate"
                onChange={(e) => setExpireDate(e.target.value)}
              />
            </Col>
          </Form.Group>
          <QuoteAssignmentComponent quoteId={id} assignedTo={quote?.assignedTo} onAssigned={handleAssigned} />

          <Button
            type="submit"
            className="CTL_btn p-1 pe-3 ps-3 m-2"
            onClick={handleUpdateNewQuote}
          >
            Submit
          </Button>
          <Button
            className="CTL_btn p-1 pe-3 ps-3 ms-2"
            onClick={() => {
              window.open("/admin/create-new-product");
            }}
          >
            Create New Product{" "}
            <i class="bi bi-box-arrow-up-right"></i>
          </Button>


          <Modal
            show={showImageModal}
            onHide={() => setShowImageModal(false)}
            centered
            size="xl"
          >
            <Modal.Body
              style={{
                textAlign: "center",
                background: "#ffffff",
              }}
            >
              <img
                src={previewImage}
                alt="preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "85vh",
                  objectFit: "contain",
                }}
              />
            </Modal.Body>
          </Modal>
        </Container>
      )}
    </>
  );
};

export default QuoteItemForQuotePageComponent;
